export enum GROUPS_PERMISSIONS {
    INSTANCE_EDIT = 'INSTANCE_EDIT',
}
